import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { gastosReportApi } from "./axios";

export interface CategoriaResumenI {
  categoriaId: number;
  codigo: string;
  nombre: string;
  icono: string | null;
  color: string | null;
  monto: number;
  porcentaje: number;
}

export interface GastosResumenI {
  anio: number;
  totalGeneral: number;
  tope: number | null;
  rebajaEstimada: number | null;
  cargasFamiliares: number;
  esCatastrofica: boolean;
  categorias: CategoriaResumenI[];
}

export interface GetGastosResumenParamsI {
  anio: number;
  cargasFamiliares?: number;
  esCatastrofica?: boolean;
}

const getGastosResumen = async (
  params: GetGastosResumenParamsI,
): Promise<{ data: GastosResumenI }> => {
  try {
    const token = ValidateCurrentToken();
    if (!token) throw new Error("TOKEN INVALIDO");
    const { data } = await gastosReportApi.get("/gastos-personales", {
      params: {
        anio: params.anio,
        cargasFamiliares: params.cargasFamiliares ?? 0,
        esCatastrofica: params.esCatastrofica ?? false,
      },
      headers: { Authorization: token },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error)?.message ?? "Error al cargar gastos");
  }
};

export const useGastosResumen = (params: GetGastosResumenParamsI) => {
  const resumenQuery = useQuery(
    ["gastos-resumen", params],
    () => getGastosResumen(params),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  return { resumenQuery };
};
